// l10n status: done
import React from "react"
import "./adCounters.css"
import ad_volumeOn from "img/player/ad_volumeOn.svg"
import ad_volumeOff from "img/player/ad_volumeOff.svg"
import ad_fullscreenEnter from "img/player/ad_fullscreenEnter.svg"
import ad_fullscreenExit from "img/player/ad_fullscreenExit.svg"
import { observer } from "mobx-react"
import CinemaModeEnable from "img/player/cinema-mode-enable-dark.svg"
import CinemaModeDisable from "img/player/cinema-mode-disable-dark.svg"
//import CinemaModeDisable from "img/player/cinema-mode-disable-dark-2.svg"
import { isIpad, isPhoneSize, isIphone, isAndroid } from "utils/Utils"
import { LightTooltip } from "components/LightTooltip"
import { l10n } from "store/lang/L10n"

// MTVW-733: Added adStyleInfo

const SkipButton = observer(({ adStyleValidCounter, adStyleInfo, source, cssClass, isFullScreen, isControlsVisible }) =>
	// MTVW-453	
	// <div className={cssClass}
	<div id="skipButton" style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 10, top: adStyleInfo?.videoBottom - 60 } : {}}
		className={`${cssClass} ${isControlsVisible ? isFullScreen ? "AdCountDownSkipButtonOnFullscreen" : "AdCountDownSkipButtonControlsOn" : ""}`}
		onClick={(e) => {
			e.stopPropagation()
			source.skipAd()
		}}
		onTouchEnd={(e) => {
			e.stopPropagation()
			e.preventDefault()
			source.skipAd()
		}}
	>
		<div className="AdContDownText ">
			{l10n.featurePlayerSkipPromo}
		</div>
	</div>
)

const visibilityHelper = (bState, style = {}) => {
	return !bState ? { visibility: "hidden", height: 0, width: 0, minWidth: 0, padding: 0 } : style
}

export const AdCounter = observer(({ page, adStyleValidCounter, adStyleInfo, isFullScreen, isControlsVisible = false }) => {
	const player = page.player
	const source = page.source
	const hasCloseButton = !(isFullScreen || source.contentPlayerName === "playerLiveTvVo") || player.isFullScreenCinema
	let counters = null

	// MTVW-727: don't show if in PiP
	if (player.isInPip) return null

	//MTVW-733: Match the breakpoints for AdMainCounterContainer in the css
	const countdownOffset = () => {
		if (adStyleInfo?.videoBottomOffset === 0) return 96
		if (adStyleInfo?.videoWidth > 960) return 96
		else if (adStyleInfo?.videoWidth > 480) return 72
		else return 44
	}

	React.useEffect(() => {
		//console.debug("AdCounter %o, closeButton %s, fs %s, valid %s", document.getElementById("closeOverlay"), hasCloseButton, isFullScreen, adStyleValidCounter)
		console.debug("AdCounter closeButton %s, fs %s, counter %s, style %o", hasCloseButton, isFullScreen, adStyleValidCounter, adStyleInfo)
	}, [hasCloseButton, isFullScreen, player.isFullScreenCinema, adStyleValidCounter])

	// MTVW-733: ultrawidescreen support, added adStyleInfo
	if (source.adState?.replay) {
		if (source.adState.replay.countdown > 0) {
			counters = <div id="adReplayCountdown" style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 24, top: adStyleInfo?.videoBottom - countdownOffset() } : {}}
				className={`AdMainCounterContainer `}>
				<div className="AdContDownText">{l10n.featurePlayerReplayCountdown.format(source.adState.replay.countdown / 1000)}</div>
			</div>
		}
	} else if (source.adState?.fastFwd) {
		if (source.adState.fastFwd.adNumber > 0) {
			counters = <div id="adCounter" style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 24, top: adStyleInfo?.videoBottom - countdownOffset() } : {}}
				className={`AdMainCounterContainer `} >
				<div className="AdCounterText">
					{l10n.featurePlayerFastforwardAdCounter.format(source.adState.fastFwd.adNumber, source.adState.fastFwd.adCount)}
				</div>
			</div>
		}
		if (source.adState.fastFwd.promoCountdown > 0) {
			counters = <div id="adCountdown" style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 24, top: adStyleInfo?.videoBottom - 60 } : {}}
				className="AdContDownPromoMain AdContDownOpacityOn">
				<div className="AdContDownText">{l10n.featurePlayerSkipPromoIn.format(source.adState.fastFwd.promoCountdown / 1000)}</div>
			</div>
		}
		if (source.adState?.fastFwd?.skip) {
			counters = <SkipButton adStyleValidCounter={adStyleValidCounter} adStyleInfo={adStyleInfo} source={source} style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 24, top: adStyleInfo?.videoBottom - 60 } : {}}
				cssClass={'AdContDownPromoMain AdCountDownSkipButton'} isFullScreen={isFullScreen} />
		}
	} else if (source.adState?.linear?.skip) {
		counters = <SkipButton adStyleValidCounter={adStyleValidCounter} adStyleInfo={adStyleInfo} source={source} id="linearSkipButton" style={isFullScreen && adStyleValidCounter > 0 ? { right: adStyleInfo?.videoRight + 10 } : {}}
			cssClass={'AdSkipLinearPromo AdCountDownSkipButton'}
			isFullScreen={isFullScreen}
			isControlsVisible={isControlsVisible} />
	}

	const clickAction = (e, action) => {
		e.stopPropagation()
		e.preventDefault()
		action()
	}

	// MTVW-733: The placement of the buttons don't work correctly without the fullscreen toggling hack in Player.orientationChange
	return (
		<div>
			<div id="adTopControlsContainer" style={isFullScreen && adStyleValidCounter > 0 ? { width: adStyleInfo?.videoWidth - 40, marginLeft: adStyleInfo?.videoRight, top: adStyleInfo?.videoTop + 10 } : {}}
				className={`${hasCloseButton ? 'AdTopControlsContainer' : 'AdTopControlsContainerFullscreen'}`}>
				<div className="VolumeControl" >
					<LightTooltip title={player.isMuted ? l10n.featureTooltipVolumeOn : l10n.featureTooltipVolumeOff} placement="bottom">
						<img src={ad_volumeOn} alt="volume on" style={visibilityHelper(!player.isMuted, {})}
							onClick={(e) => {
								clickAction(e, () => player.setMuteState(true))
							}}>
						</img>
						<img src={ad_volumeOff} alt="volume on" style={visibilityHelper(player.isMuted, {})}
							onClick={(e) => {
								clickAction(e, () => player.setMuteState(false))
							}}>
						</img>
					</LightTooltip>
				</div>

				<div className="FullscreenControl" style={{ width: !isPhoneSize() && !isAndroid() && !isIpad() ? "80px" : "32px" }}>
					{!isPhoneSize() && !isAndroid() && !isIpad() /*&& page.isPlayerOnOverlay*/ &&
						<>
							<LightTooltip title={player.isFullScreenCinema ? l10n.featureTooltipCinemamodeOff : l10n.featureTooltipCinemamodeOn} placement="bottom">
								<img className="ButtonIcon" src={CinemaModeDisable} data-test="player_cinemamode" alt="cinema mode exit" style={visibilityHelper(player.isFullScreenCinema, { /*color: "#ffffff", backgroundColor: "#404040", opacity: "0.5", borderRadius: "50%",*/ marginRight: "6px" })}
									onClick={(e) => {
										clickAction(e, () => source.setFullScreen(null, true))
									}}>
								</img>
								<img className="ButtonIcon" src={CinemaModeEnable} data-test="player_cinemamode" alt="cinema mode enter" style={visibilityHelper(!player.isFullScreenCinema, { /*color: "#ffffff", backgroundColor: "#404040", opacity: "0.5", borderRadius: "50%",*/ marginRight: "6px" })}
									onClick={(e) => {
										clickAction(e, () => {
											if (isFullScreen && !player.isFullScreenCinema) {
												source.setFullScreen(false).then(() => {
													source.setFullScreen(null, true)
												})
											}
											else source.setFullScreen(null, true)
										})
									}}>
								</img>
							</LightTooltip>
						</>
					}
					<LightTooltip title={player.settings.isFullScreen ? l10n.featureTooltipFullscreenOff : l10n.featureTooltipFullscreenOn} placement="bottom">
						<img className="ButtonIcon" src={ad_fullscreenEnter} data-test="player_fullscreen" alt="fullscreen enter" style={visibilityHelper(!isFullScreen, {})}
							onClick={(e) => {
								clickAction(e, () => source.setFullScreen(null))
							}}>
						</img>
						<img className="ButtonIcon" src={ad_fullscreenExit} data-test="player_fullscreen" alt="fullscreen exit" style={visibilityHelper(isFullScreen, {})}
							onClick={(e) => {
								clickAction(e, () => source.setFullScreen(null))
							}}>
						</img>
					</LightTooltip>
				</div>
			</div>

			<div>{counters}</div>
		</div>
	)
})
